<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">Dashboard</router-link>
            <router-link to="/school/hostel-management" class="text-white">
                <i class="fa fa-ellipsis-v mx-2"></i>Hostel Management
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v mx-2"></i>Hostel Beds</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="card bg-secondary">
                                <h3 class=" card-header">Registration</h3>
                                <div class="card-body">
                                    <div class="form-horizontal">
                                        <form role="form" @submit.prevent="submitdata">
                                            <div class="form-group">
                                                <label>Hostel</label>
                                                <select v-model="HostelIdval" @change="GetHostelFloor()"
                                                    class="form-control">
                                                    <option value="0" v-if="!HostelItems">⏳ Loading...</option>
                                                    <option value="0" v-else>- Select Hostel -</option>
                                                    <option v-for="item in HostelItems" :key="item.Id"
                                                        v-bind:value="item.Id">
                                                        {{ item.HostelName }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>Floor</label>
                                                <select v-model="FloorIdval" @change="GetHostelRoom()"
                                                    class="form-control">
                                                    <option value="0" v-if="!HostelFloorItems">⏳ Loading...</option>
                                                    <option value="0" v-else>- Select Floor -</option>
                                                    <option v-for="item in HostelFloorItems" :key="item.Id"
                                                        v-bind:value="item.Id">
                                                        {{ item.FloorName }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>Room Number</label>
                                                <select v-model="RoomIdval" @change="GetHostelBed()"
                                                    class="form-control">
                                                    <option value="0" v-if="!HostelRoomItems">⏳ Loading...</option>
                                                    <option value="0" v-else>- Select Rooms -</option>
                                                    <option v-for="item in HostelRoomItems" :key="item.Id"
                                                        v-bind:value="item.Id">
                                                        {{ item.RoomNo }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>Bed Number</label>
                                                <input v-model="BedNoval" class="form-control" required />
                                            </div>
                                            <div class="text-center card-footer">
                                                <button type="submit" class="btn btn-primary">
                                                    Submit
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="justify-content-end form-inline mt-3">
                                <base-input class="input-group-alternative" placeholder="Search here..."
                                    addon-left-icon="fa fa-search" v-model="searchval">
                                </base-input>
                            </div>
                            <div class="table-responsive mt-2">
                                <table class="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Bed No.</th>
                                            <th>Room No.</th>
                                            <th>Floor Name</th>
                                            <th>Hostel Name</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in searchedResultQuery" :key="item.Id">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ item.BedNo }}</td>
                                            <td>{{ item.RoomNo }}</td>
                                            <td>{{ item.FloorName }}</td>
                                            <td>{{ item.HostelName }}</td>
                                            <td>
                                                <button class="btn btn-secondary btn-sm" v-on:click="edititem(item.Id)">
                                                    <i class="fa fa-edit"></i> Edit
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import HostelMixin from "@/mixins/Hostel.mixin";
import PageSpinner from "@/components/PageSpinner";
export default {
    name: "Hostel",
    mixins: [HostelMixin, Alert],
    components: {
        PageSpinner
    },
    data() {
        return {
            accessDetails: null,
            Idval: 1,
            HostelIdval: 0,
            FloorIdval: 0,
            RoomIdval: "",
            BedNoval: "",
            HostelItems: null,
            HostelFloorItems: null,
            HostelRoomItems: null,
            HostelBedItems: null,
            searchval: "",
            process: "N",
            onloader: "none"
        };
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.HostelBedItems.filter(item => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            v =>
                                item.HostelName.toLowerCase().includes(v) ||
                                item.FloorName.toLowerCase().includes(v) ||
                                item.RoomNo.toLowerCase().includes(v) ||
                                item.BedNo.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.HostelBedItems;
            }
        }
    },
    methods: {
        edititem(Id) {
            this.onloader = "flex";
            let RoomId = this.RoomIdval;
            let userdata = { Id, RoomId };
            this.$store
                .dispatch("hostelBed/GetByIdHostelBed", userdata)
                .then(resp => {
                    this.Idval = Id;
                    this.HostelIdval = resp.HostelId;
                    this.FloorIdval = resp.FloorId;
                    this.RoomIdval = resp.RoomId;
                    this.BedNoval = resp.BedNo;
                    this.process = "U";
                    this.onloader = "none";
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        submitdata() {
            let Id = this.Idval;
            let RoomId = this.RoomIdval;
            let BedNo = this.BedNoval;
            let processop = this.process;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let userdata = {
                Id,
                RoomId,
                BedNo,
                processop,
                username,
                accesskey
            };
            this.onloader = "flex";
            this.$store
                .dispatch("hostelBed/ProcessHostelBed", userdata)
                .then(resp => {
                    this.HostelBedItems = resp;
                    this.BedNoval = "";
                    this.process = "N";
                    this.onloader = "none";
                    this.ShowAlertSuccess('Submitted Successfully', '');
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetHostelFloor() {
            this.HostelBedItems = null;
            this.onloader = "flex";
            this.$store
                .dispatch("hostelFloor/GetHostelFloor", this.HostelIdval)
                .then(resp => {
                    this.HostelFloorItems = resp;
                    this.onloader = "none";
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetHostelRoom() {
            this.HostelBedItems = null;
            this.onloader = "flex";
            this.$store
                .dispatch("hostelRoom/GetHostelRoom", this.FloorIdval)
                .then(resp => {
                    this.HostelRoomItems = resp;
                    this.onloader = "none";
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetHostelBed() {
            this.onloader = "flex";
            this.$store
                .dispatch("hostelBed/GetHostelBed", this.RoomIdval)
                .then(resp => {
                    this.HostelBedItems = resp;
                    this.onloader = "none";
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        if (this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch('auth/Logout')
            this.$router.push('/login')
        }
    }
};
</script>

<style></style>
